<template>
    <FullFillBox
        :pageID="1004"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <h4>{{ $t('inventory_stock_out_temp') }}</h4>
        <hr>
        <div class="row">
            <div class="col-lg-8"></div>
            <div class="col-lg-4">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="transKey">{{ $t('table_key') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                    <option value="lid">{{ $t('table_location') }}</option>
                </select>
            </div>
        </div>
        <hr>
        <div ref="tabulatorTableUse"></div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "InventoryStockOutTempTableView",
    components: {
        FullFillBox,
    },
    data(){
        return{
            permissionDetails: {},
            groupBy: 'no',
        }
    },
    methods: {
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.tabulator.setGroupBy("")
                this.tabulator.setSort("record_key", "desc");
            }else if(this.groupBy === "transKey"){
                this.tabulator.setGroupBy("record_key")
                this.tabulator.setSort("record_key", "desc");
            }else if(this.groupBy === "outCode"){
                this.tabulator.setGroupBy("outCode")
                this.tabulator.setSort("outCode", "asc");
            }else if(this.groupBy === "lid"){
                this.tabulator.setGroupBy("location_name")
                this.tabulator.setSort("location_name", "asc");
            }
            this.tabulator.redraw()
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/inventory/stock-out-temp-view/')
                .then(response => {
                    if(response.data.status === 80){
                        this.tabulator.setData(response.data.details)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_out_temp')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {
                    title: this.$t('table_key'), field: 'record_key', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 200,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_key_remarks'), field: 'record_keyRemarks', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 200, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_stock_out_date'), field: 'stockOutDate', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 200, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_show_name'), field: 'show_name', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 200, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_outCode_short'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 200,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_product_en'), field: 'product_name', sorter: 'string', resizable: true,
                    responsive: 1, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'string', resizable: true,
                    responsive: 1,widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 300, width: 300,
                    headerFilter: "input", headerMenu: this.getHeaderMenu,
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
        })
        this.getBackendData()
    }
}
</script>

<style scoped>

</style>
